import React, { Component } from 'react';
import titleImg from '../img/title_img.jpg';
import '../styles/home.css';

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      thanksSent: false,
    };
  }

  componentDidMount() {
    this.checkMsg();
  }

  checkMsg() {
    if (this.props.location.state !== undefined) {
      this.setState({ thanksSent: true });
    }
  }
  render() {
    return (
      <div className="homeContainer">
        <div className={this.state.thanksSent ? 'thanksBanner' : 'hidden'}>
          <h4>Thank you for reaching out! I will be in contact soon.</h4>
        </div>
        <img src={titleImg} alt="Welcome to Kitty Tuttle Interiors" />
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/containers/home.js